import React from 'react';
import { Music, ArrowRight, Check } from 'lucide-react';
import Reveal from './Reveal';
import { ADDON_PRICES } from '../utils/orderPricing';

export const MakeItPersonal = ({ added, onAdd }) => (
  <Reveal className="max-w-5xl mx-auto mb-16" data-testid="make-it-personal-section">
    <div className="relative overflow-hidden rounded-3xl border border-amber-500/30 bg-gradient-to-br from-amber-500/[0.08] via-black to-black p-8 md:p-12">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-amber-500/10 blur-3xl pointer-events-none" />
      <div className="relative grid md:grid-cols-[auto,1fr,auto] gap-8 items-center">
        <div className="w-16 h-16 rounded-full border border-amber-500/50 bg-black flex items-center justify-center">
          <Music size={26} className="text-amber-400" strokeWidth={1.5} />
        </div>
        <div className="space-y-3">
          <p className="uppercase tracking-[0.3em] text-xs text-amber-400">Optional Upgrade</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white font-editorial leading-tight">Make It Even More Personal</h2>
          <p className="text-gray-300 leading-relaxed max-w-xl">
            Your memories deserve more than music. Add a personalised song inspired by your story, your special people and the moments that matter most.
          </p>
          <p className="text-lg font-semibold text-amber-300" data-testid="make-it-personal-price">
            Add a Personalised Song +£{ADDON_PRICES.song}
          </p>
        </div>
        <button
          type="button"
          onClick={onAdd}
          data-testid="make-it-personal-btn"
          className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full font-semibold bg-gradient-to-r from-amber-500 to-amber-600 text-black hover:from-amber-600 hover:to-amber-700 transition-transform duration-300 hover:scale-105 active:scale-95 shadow-xl"
        >
          {added ? <><Check size={18} /> Song Added - Go to Order Form</> : <>Add to My Order <ArrowRight size={18} /></>}
        </button>
      </div>
    </div>
  </Reveal>
);

export default MakeItPersonal;
